// src/pages/CourseDetailPage.jsx
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCourseByIdQuery } from '../../api/apiSlice';
import CourseDetail from '../../components/course/CourseDetail';
import { AlertTriangle, ArrowLeft, BookOpen } from 'lucide-react';
import Loading from '../../components/common/Loading';

const CourseDetailPage = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const { data: course, error, isLoading, isError } = useGetCourseByIdQuery(courseId);

  const goBack = () => navigate(-1);

  if (isLoading) {
    return <Loading variant="card" label="Загрузка курса" description="Пожалуйста, подождите…" />;
  }

  if (isError) {
    return (
        <div className="flex items-center justify-center min-h-[60vh] px-4 py-8">
          <div className="w-full max-w-lg rounded-3xl border border-red-100 dark:border-red-900/40 bg-white dark:bg-gray-900 shadow-xl p-6 sm:p-8 text-center">
            <div className="flex justify-center mb-5">
              <div className="rounded-full bg-red-100 dark:bg-red-500/10 p-4">
                <AlertTriangle className="w-10 h-10 sm:w-12 sm:h-12 text-red-500" />
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
              Ошибка загрузки курса
            </h2>

            <p className="text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
              {error?.data?.message || 'Не удалось загрузить курс. Попробуйте позже.'}
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                  onClick={goBack}
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg"
              >
                <ArrowLeft className="w-4 h-4" />
                Назад
              </button>

              <button
                  onClick={() => window.location.reload()}
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
              >
                Повторить
              </button>
            </div>
          </div>
        </div>
    );
  }

  if (!course) {
    return (
        <div className="flex items-center justify-center min-h-[60vh] px-4 py-8">
          <div className="w-full max-w-lg rounded-3xl border border-yellow-100 dark:border-yellow-900/40 bg-white dark:bg-gray-900 shadow-xl p-6 sm:p-8 text-center">
            <div className="flex justify-center mb-5">
              <div className="rounded-full bg-yellow-100 dark:bg-yellow-500/10 p-4">
                <BookOpen className="w-10 h-10 sm:w-12 sm:h-12 text-yellow-500" />
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
              Курс не найден
            </h2>

            <p className="text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
              Курс, который вы ищете, не существует или временно недоступен.
            </p>

            <button
                onClick={goBack}
                className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg"
            >
              <ArrowLeft className="w-4 h-4" />
              Вернуться назад
            </button>
          </div>
        </div>
    );
  }

  return (
      <div className="max-w-7xl mx-auto">
        <button
            onClick={goBack}
            className="mb-1.5 sm:mb-2 inline-flex items-center gap-2 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Назад
        </button>

        <div className="rounded-2xl overflow-hidden">
          <CourseDetail course={course} />
        </div>
      </div>
  );
};

export default CourseDetailPage;